(function() {
    'use strict';
    angular.module('emarket.commons').directive('goBack', ['$state', '$window', function($state, $window) {
        return {
            link: function(scope, element) {
                element.on('click', function() {
                    if(!$state.previous) {
                        return $state.go('main.home');
                    }
                    $window.history.back();
                });
            }
        };
    }]);
}());
